/** Tipos de incidencia (WAVE-289 · ITM-SUPPORT-PORTAL-UX-01). */

export const ISSUE_TYPES = [
  { id: 'wifi', label: 'WiFi', prefix: 'WiFi' },
  { id: 'phone', label: 'Telefonía', prefix: 'Telefonía' },
  { id: 'cctv', label: 'Cámaras', prefix: 'Cámaras' },
  { id: 'network', label: 'Red', prefix: 'Red' },
  { id: 'other', label: 'Otro', prefix: '' },
]

export function issueChipsHtml(name = 'issue_type', selected = 'wifi') {
  return `
    <div class="issue-chips" role="radiogroup" aria-label="Tipo de incidencia">
      ${ISSUE_TYPES.map(
        (t) => `
        <label class="issue-chip">
          <input type="radio" name="${name}" value="${t.id}" ${t.id === selected ? 'checked' : ''} />
          <span>${t.label}</span>
        </label>`
      ).join('')}
    </div>`
}

export function selectedIssuePrefix(form, name = 'issue_type') {
  const id = form?.querySelector(`input[name="${name}"]:checked`)?.value
  return ISSUE_TYPES.find((t) => t.id === id)?.prefix || ''
}

function stripKnownPrefix(value) {
  let s = String(value || '')
  for (const t of ISSUE_TYPES) {
    if (!t.prefix) continue
    s = s.replace(new RegExp(`^${t.prefix}\\s*:\\s*`, 'i'), '')
  }
  return s
}

export function applyIssueToSubject(form, subjectEl, name = 'issue_type') {
  if (!form || !subjectEl) return
  const prefix = selectedIssuePrefix(form, name)
  const rest = stripKnownPrefix(subjectEl.value)
  subjectEl.value = prefix ? `${prefix}: ${rest}`.replace(/\s+$/, '').replace(/:\s*$/, ': ') : rest
}

export function composeSubject(form, subjectEl, descEl, name = 'issue_type') {
  const prefix = selectedIssuePrefix(form, name)
  let subject = String(subjectEl?.value || '').trim()
  if (!subject) {
    const desc = String(descEl?.value || '')
      .trim()
      .split('\n')[0]
      .slice(0, 80)
    subject = prefix && desc ? `${prefix}: ${desc}` : desc || prefix
  }
  return subject
}

export const SLA_HINT =
  'Respuesta habitual en menos de 2 horas en horario de contrato. El canal preferente es el ticket.'
